import KvCarouselItem from "./KvCarouselItem";

class KvCarousel {
  // ---------------------------------------------------------------------------
  // --	KvCarousel
  // ---------------------------------------------------------------------------

  constructor() {
    //スライド用のインデックス
    this.index = 0;

    //DOM参照
    this.$elm = document.querySelector(".p-home-hero__carousel");
    this.$timer = document.querySelector(".p-home-hero__carousel-timer");

    //アイテム生成＆タイマー配置
    let html = "";
    this.items = [];
    this.$elm.querySelectorAll(".p-home-carousel__item").forEach((elm) => {
      const item = new KvCarouselItem(elm);
      this.items.push(item);
      html +=
        '<li class="p-home-hero__carousel-timer-item"><span class="bar"></span></li>';
    });
    this.$timer.innerHTML = html;

    //リサイズハンドリング
    this.onResizeHandler = this.onResize.bind(this);
    window.addEventListener("resize", this.onResizeHandler);
    this.onResize();

    //最初のアイテム表示
    const item = this.items[this.index];
    item.show(0);
  }

  /**
   * スタート
   */
  start() {
    this.loop();
  }

  /**
   * ループ処理
   */
  loop(duration = 5) {
    //タイマーバー参照
    const bars = this.$timer.querySelectorAll(".bar");

    //バーを初期化
    bars.forEach((bar) => {
      bar.style.width = "0%";
    });

    //KV切り替え
    gsap.delayedCall(duration - 2.0, this.change.bind(this));

    //バー
    const bar = bars[this.index];
    gsap.to(bar, {
      width: "100%",
      duration: duration,
      ease: "none",
      onComplete: this.loop.bind(this),
    });
  }

  /**
   * KVの切り替え
   */
  change() {
    //表示中のアイテムを隠す
    const prevItem = this.items[this.index];
    this.$elm.querySelector(".p-home-carousel").appendChild(prevItem.$elm);
    prevItem.hide();

    //インデックス変更
    if (++this.index >= this.items.length) this.index = 0;

    //次のアイテムを表示する
    const nextItem = this.items[this.index];
    nextItem.show();
  }

  // ---------------------------------------------------------------------------
  // --	リサイズ
  // ---------------------------------------------------------------------------

  /**
   * リサイズハンドリング
   */
  onResize() {
    //カルーセルエリアのサイズ
    const size = {
      width: this.$elm.clientWidth,
      height: this.$elm.clientHeight,
    };

    //写真の幅と位置を更新
    document
      .querySelector(":root")
      .style.setProperty("--carousel-width", `${size.width}px`);
    document
      .querySelector(":root")
      .style.setProperty("--carousel-margin-left", `-${size.width / 2}px`);

    //傾きを計算
    const skewW = (size.height / 2) * Math.tan(40 * (Math.PI / 180));

    // const test = 33 * Math.tan(40 * (Math.PI / 180));
    // console.log(test);

    //傾き幅を更新
    document
      .querySelector(":root")
      .style.setProperty("--carousel-skew-width", `-${skewW}px`);

    //マスクの幅を更新
    document
      .querySelector(":root")
      .style.setProperty(
        "--carousel-mask-width",
        `${size.width + skewW * 2}px`
      );
  }

  // ---------------------------------------------------------------------------
}

export default KvCarousel;
